<template>
    <div >
        <PageHeader>
            <template #navbar>
                <Navbar />
            </template>
            <template #pagetitle>
                <PageTitle
                    :pageTitle="$t('pages.titles.productOne')"
                    :pageParentTitle="$t('pages.parents.products')"
                />
            </template>
        </PageHeader>
        <About />
        <AboutReverse />
        <About2 />
        <AboutReverse2 />
        <FreeTrial variant="light"/>
        <Footer />
    </div>
</template>

<script>
import Navbar from '../Layout/Navbar'
import PageHeader from '../Layout/PageHeader'
import FreeTrial from '../Common/FreeTrial'
import PageTitle from '../Common/PageTitle'
import AboutReverse2 from '../Product/One/AboutReverse2'
import About2 from '../Product/One/About2'
import Footer from '../Layout/Footer'
import AboutReverse from '../Product/One/AboutReverse'
import About from '../Product/One/About'



export default {
    name: 'SearchPage',
    components: {
        Navbar,
        PageTitle,
        PageHeader,
        FreeTrial,
        Footer,
        AboutReverse,
        About,
        AboutReverse2,
        About2,
    }
}
</script>
